import {getMissionChecker} from "./ContentsMissions";

export default class OnlineCodingParty {
  constructor(graphics) {
    this.ctx = graphics;

    this.missionIndex = 0;
  }

  init() {
    let {id, missionIndex} = this.ctx.sceneEdit.userData.onlineCodingParty;

    // [TEMP] 모든 미션을 성공한 경우 예외 처리. 모든 미션을 성공한 유저가 다시 프로젝트를 열었을 때 어떻게 할 것인지에 대한 기획이 있는가
    if ((id === "OnCoPart23_0" || id === "OnCoPart23_1") && missionIndex > 5) missionIndex = 5;
    else if (id === "OnCoPart23_2" && missionIndex > 4) missionIndex = 4;

    this.ctx.dispatchEvent(new CustomEvent("tutorial-initialization", {detail: {contentsId: id, missionIdx: missionIndex}}));
    this.missionIndex = missionIndex;

    const {_onInit, _onPlayStart, _onPlayEnd, _onPlaying, _onReset} = getMissionChecker(id);
    this.onPlayStart = _onPlayStart.bind(this);
    this.onPlayEnd = _onPlayEnd.bind(this);
    this.onPlaying = _onPlaying.bind(this);
    this.onReset = _onReset.bind(this);
    _onInit.bind(this)();
  }

  onPlayStart() {}

  onPlayEnd() {}

  onPlaying() {}

  onReset() {}

  updateState(missionIdx, completedMissionIdx) {
    if (this.missionIndex !== missionIdx) {
      this.missionIndex = missionIdx;
      this.onReset();
    }
    if (this.ctx.sceneEdit.userData.onlineCodingParty.missionIndex <= completedMissionIdx) {
      this.ctx.sceneEdit.userData.onlineCodingParty.missionIndex = completedMissionIdx + 1;
      this.ctx.autoSaveProject();
      // this.ctx.saveProject(); // autosave와 save 중 UX 면에서 뭐가 더 좋을지
      // [TODO] changeMode automatically?
    }
  }

  reset(fromChangeMode, idx = this.missionIndex) {}

  update() {
    // this.success = this.onPlaying();
  }
}
